
/* eslint-disable */
// export const BASE_URL = 'http://127.0.0.1:8001/' // Local
export const BASE_URL = 'https://kosamba-api.rayzon.one/' // Production
